import { useQuery } from "react-query";
import { apiGet } from "../api/client";
import { getApiToken } from "../data/api/token";
import { useUserSession } from "../context/UserContext";
import { DriverTimeEntries } from "../components/Driver/timeEntries";

export function useDriverTimeEntries(
  workspaceId: string,
  driverId: string,
  from: string,
  to: string,
) {
  const { userSession } = useUserSession();
  return useQuery<DriverTimeEntries>(
    [
      "driver-time-entries",
      userSession?.user.userId || userSession?.user.id,
      workspaceId,
      driverId,
      from,
      to,
    ],
    async () => {
      const query = new URLSearchParams({ from, to });
      const result = await apiGet(
        await getApiToken(),
        `/api/drivers/${encodeURIComponent(driverId)}/time-entries?${query}`,
        workspaceId,
      );
      return result.data;
    },
    {
      enabled: !!userSession && !!workspaceId && !!driverId,
      staleTime: 0,
      cacheTime: 0,
      retry: false,
      refetchOnWindowFocus: true,
    },
  );
}
